import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Badge from 'react-bootstrap/Badge'
import axios from 'axios'

const Wishlist = () => {
  const [courses, setCourses] = useState([])
  const [displayedCards, setDisplayedCards] = useState(6)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  const redirect = (id) => {
    navigate(`/Course/${id}`)
  }

  const defaultThumbnail =
    'https://via.placeholder.com/300x150.png?text=No+Image'

  useEffect(() => {
    const token = localStorage.getItem('jwttoken')
    axios
      .get('https://kaasbackend.vetrinahealthcare.com/lms/user/wishlist/', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setCourses(response.data)
        console.log(response.data)
        setLoading(false)
      })
      .catch((error) => {
        console.error('Error fetching courses:', error)
        setError('Failed to load courses. Please try again.')
        setLoading(false)
      })
  }, [])

  const removeCourseFromWishlist = (courseId) => {
    const token = localStorage.getItem('jwttoken')
    axios
      .delete(`https://kaasbackend.vetrinahealthcare.com/lms/user/wishlist/${courseId}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setCourses((prevCourses) =>
          prevCourses.filter(
            (courseWrapper) => courseWrapper.course.course_id !== courseId
          )
        )
      })
      .catch((error) => {
        console.error('Error removing course:', error)
      })
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <div className='spinner-border' role='status' />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h5>{error}</h5>
      </div>
    )
  }

  return (
    <div>
      <Header />
      <div
        style={{
          padding: '20px 20px',
          backgroundColor: '#f4f4f9',
          borderRadius: '15px',
          marginTop:'70px',
        }}
      >
        <h1
          style={{
            fontSize: '2.8rem',
            fontWeight: '700',
            textAlign: 'center',
            color: '#34495e',
            marginBottom: '10px',
          }}
        >
          Your Wishlist
        </h1>
        <div className='row' id='myCourse'>
          {courses.length > 0 ? (
            courses.slice(0, displayedCards).map((courseWrapper) => {
              const { course } = courseWrapper
              return (
                <div key={course.course_id} className='col-md-4 mb-4'>
                  <Card
                    className='shadow-sm h-100'
                    style={{
                      borderRadius: '12px',
                      overflow: 'hidden',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.02)'
                      e.currentTarget.style.boxShadow =
                        '0 10px 20px rgba(0, 0, 0, 0.2)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)'
                      e.currentTarget.style.boxShadow =
                        '0 5px 10px rgba(0, 0, 0, 0.1)'
                    }}
                  >
                    {course.trailer ? (
                      <video
                        src={course.trailer}
                        style={{
                          height: '220px',
                          objectFit: 'cover',
                          borderTopLeftRadius: '12px',
                          borderTopRightRadius: '12px',
                        }}
                        controls
                        onError={(e) => {
                          e.target.src = defaultThumbnail // Optional fallback to default thumbnail on video load error
                        }}
                      ></video>
                    ) : (
                      <div
                        style={{
                          height: '220px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f4f4f4',
                          color: '#7f8c8d',
                          borderTopLeftRadius: '12px',
                          borderTopRightRadius: '12px',
                          fontSize: '1rem',
                          fontStyle: 'italic',
                        }}
                      >
                        No trailer provided by instructor
                      </div>
                    )}

                    <Card.Body style={{ padding: '20px' }}>
                      <Card.Title
                        style={{
                          fontSize: '1.4rem',
                          fontWeight: 'bold',
                          color: '#2c3e50',
                        }}
                      >
                        {course.title}
                      </Card.Title>
                      <Card.Text
                        style={{
                          fontSize: '1rem',
                          color: '#7f8c8d',
                          marginBottom: '15px',
                        }}
                      >
{course.description ? `${course.description.substring(0, 90)}...` : 'No description available.'}
</Card.Text>
                      <div className='d-flex flex-wrap mt-2'>
                        {course.categories &&
                          course.categories.map((category, index) => (
                            <Badge
                              key={index}
                              bg='secondary'
                              style={{
                                margin: '2px',
                                backgroundColor: '#3498db',
                                fontSize: '0.85rem',
                              }}
                            >
                              {category}
                            </Badge>
                          ))}
                      </div>
                      <div className='d-flex justify-content-between align-items-center mt-4'>
                        <Button
                          variant='outline-primary'
                          onClick={() => redirect(course.course_id)}
                          style={{
                            borderColor: '#3498db',
                            color: '#3498db',
                            fontWeight: '600',
                          }}
                        >
                          View Course
                        </Button>
                        <Button
                          variant='outline-danger'
                          onClick={() =>
                            removeCourseFromWishlist(course.course_id)
                          }
                          style={{
                            borderColor: '#e74c3c',
                            color: '#e74c3c',
                            fontWeight: '600',
                          }}
                        >
                          Remove
                        </Button>
                      </div>
                    </Card.Body>
                    <Card.Footer
                      className='text-muted'
                      style={{ textAlign: 'center' }}
                    >
                      <div style={{ fontSize: '1rem', color: '#7f8c8d' }}>
                        <strong>Price:</strong> ₹{course.price} &nbsp; | &nbsp;{' '}
                        <strong>Ref:</strong> #{course.reference_num}
                      </div>
                    </Card.Footer>
                  </Card>
                </div>
              )
            })
          ) : (
            <div className='col-12 text-center'>
              <h5>No Courses Available</h5>
            </div>
          )}
        </div>
        {courses.length > displayedCards && (
          <div className='text-center mt-5'>
            <Button
              onClick={() => setDisplayedCards(displayedCards + 6)}
              style={{
                backgroundColor: '#3498db',
                color: 'white',
                border: 'none',
                padding: '12px 25px',
                fontSize: '1.1rem',
                borderRadius: '8px',
              }}
            >
              Load More
            </Button>
          </div>
        )}
      </div>
      <Footer />
    </div>
  )
}

export default Wishlist
